document.querySelectorAll( '.b-dropdown-content' ).forEach( ( block ) => {

	const dropdownWrapper = block.querySelector( '.js-dropdown' );
	const dropdownButton = block.querySelector( '.js-dropdown-button' );
	const dropdownCurrent = block.querySelector( '.js-dropdown-current' );
	const dropdownOptions = block.querySelectorAll( '.js-dropdown-option' );
	const dropdownButtonLatest = block.querySelector( '.js-dropdown-latest' );
	const allPanels = block.querySelectorAll( '.js-dropdown-content' );

	/**
	 * Shows the panel with the specified ID and hides others.
	 * @param {string} panelId - The ID of the panel to display.
	 */
	const showPanel = ( panelId ) => {

		allPanels.forEach( panel => panel.classList.remove( 'active' ) );
		const target = block.querySelector( `[id="${panelId}"]` );
		if ( target ) {

			target.classList.add( 'active' );

		}

	};

	/**
	 * Sets the current option in the dropdown and highlights it.
	 * @param {HTMLElement} option - The option element to set as current.
	 */
	const setCurrentOption = ( option ) => {

		dropdownWrapper
			.querySelectorAll( '.b-dropdown-content__dropdown-option' )
			.forEach( li => li.classList.remove( 'current' ) );

		option.closest( 'li' ).classList.add( 'current' );
		dropdownCurrent.textContent = option.textContent.trim();

	};

	/**
	 * Updates the state of the "latest" button based on the selected index.
	 * @param {number} index - The index of the selected option.
	 */
	const updateLatestButton = ( index ) => {

		if ( !dropdownButtonLatest ) {

			return;

		}

		if ( index !== 0 ) {

			dropdownButtonLatest.classList.add( 'active' );

		} else {

			dropdownButtonLatest.classList.remove( 'active' );

		}

	};

	/**
	 * Selects the first option and updates the dropdown and panel.
	 */
	const selectFirstOption = () => {

		const firstOption = dropdownOptions[0];
		if ( !firstOption ) {

			return;

		}

		const navId = firstOption.id.replace( '-nav', '' );
		const panelId = `${navId}-panel`;

		showPanel( panelId );
		setCurrentOption( firstOption );
		dropdownButtonLatest?.classList.remove( 'active' );

	};

	if ( dropdownButton ) {

		dropdownButton.addEventListener( 'click', ( event ) => {

			event.stopPropagation();
			event.preventDefault();
			dropdownWrapper.classList.toggle( 'active' );

		} );

	}

	document.addEventListener( 'click', ( event ) => {

		if ( !dropdownButton.contains( event.target ) ) {

			dropdownWrapper.classList.remove( 'active' );

		}

	} );

	dropdownOptions.forEach( ( option, index ) => {

		option.addEventListener( 'click', () => {

			const navId = option.id.replace( '-nav', '' );
			const panelId = `${navId}-panel`;

			showPanel( panelId );
			setCurrentOption( option );
			dropdownWrapper.classList.remove( 'active' );
			updateLatestButton( index );

		} );

	} );

	if ( dropdownButtonLatest ) {

		dropdownButtonLatest.addEventListener( 'click', ( event ) => {

			event.preventDefault();
			selectFirstOption();

		} );

	}

	selectFirstOption();

} );
